import api from "./api";

/**
 * @method 鱼产力 新增/补充
 */
export const addFishProductivity = (params) =>
  api.post(`/api/FishProductivity`, params);

/**
 * 开卡
 */
export const openCard = (params) => api.post(`/api/WeighingCardInfo`, params);

/**
 * 充值
 */
export const recharge = (params) =>
  api.post(`/api/WeighingCardInfo/Recharge`, params);

/**
 * 通过真实卡号获得卡信息
 */
export const getByCardNumber = (cardNumber) =>
  api.get(`/api/WeighingCardInfo/GetByCardNumber?cardNumber=${cardNumber}`);

/**
获取一体称网点后台首页 交易品类占比
 * 
 */
export const GetCardByPhone = (DealerType, Phone) =>
  api.get(
    `/api/WeighingCardInfo/GetCardByPhone?DealerType=${DealerType}&Phone=${Phone}`,
    {}
  );

/**
 * 卡片管理 卡片详情页 结算记录
 */
export const getCardRecord = (params) =>
  api.get(`/api/WeighingCardInfo/GetCardSettlePage`, {
    params,
  });

/**
 * 卡片管理 修改卡状态
 */
export const updateCardStatus = (params) =>
  api.post(`/api/WeighingCardInfo/UpdateStatus`, params);

/**
 * 卡片管理 卡片详情页 提现、查询记录
 */
export const getRecord = (params) =>
  api.get(`/api/WeighingCardInfo/GetCardStatementPage`, {
    params,
  });

/**
 * 损益单列表
 */
export const getGainLoss = (params) =>
  api.get(`/api/GainsLoss/Detail`, {
    params,
  });

/**
 * 损益单明细报表
 */
export const getGainLossDetail = (params) =>
  api.get(`/api/GainsLoss/GetDetailToPC`, {
    params,
  });

/**
 * 损益单汇总报表
 */
export const getGainLossTotal = (params) =>
  api.get(`/api/GainsLoss/TransferSummary`, {
    params,
  });
/* 通过真实卡号获得卡信息
 */
export const getCardNumber = (cardNumber) =>
  api.get(
    `/api/WeighingCardInfo/GetCardShowNumberByCardNumber?cardNumber=${cardNumber}`
  );

/**
 * 进行开卡
 */
export const addCard = (params) => api.post(`api/WeighingCardInfo`, params);

/**
 * 获取批次报表接口（新）
 */

export const getBatchReportNew = (params) =>
  api.get(`/api/WeighingProductReport/GetBatchReport`, {
    params,
  });

/**
 * 修改卡模式
 */

export const updatePadMode = (params) =>
  api.post(`/api/WeighingCardInfo/UpdatePadMode`, params);

/**
 * 获取收/付款汇总表
 */

export const getPaymentTotal = (params) =>
  api.get(`/api/Finance/GetPaySummaryReport`, {
    params,
  });

/**
 * 获取公司付款设置
 */
export const getEnterprisePayMode = (params) =>
  api.get(`/api/Enterprise/GetEnterprisePayMode`);

/**
 *修改公司付款设置
 */

export const UpdateEnterprisePayMode = (params) =>
  api.post(`/api/Enterprise/UpdatePayMode`, params);

/**
 * @method 获取当前公司
 */
export const getCompany = () => api.get("/api/Enterprise/Simple");

/**
 * @method 获取大数据首页销售数据
 */
export const getBigData = (params) =>
  api.get(`/api/WeighingBigData`, {
    params,
  });

/**
 * @method 产品销售统计柱状图
 */
export const getSpecRate = (params) =>
  api.get(`/api/WeighingBigData/GetSaleDeal`, {
    params,
  });

/**
 * @method 产品销售占比
 */
export const getShopRate = (params) =>
  api.get(`/api/WeighingBigData/GetProductSaleRate`, {
    params,
  });

/**
 * @method 产品采购柱状图
 */
export const getPurchaseDeal = (params) =>
  api.get(`/api/WeighingBigData/GetPurchaseDeal`, {
    params,
  });

/**
 * @method 产品采购占比
 */
export const getProductPurchaseRate = (params) =>
  api.get(`/api/WeighingBigData/GetProductPurchaseRate`, {
    params,
  });

/**
 * @method 仓库损益情况柱状图
 */
export const getWarehouseGrinLoss = (params) =>
  api.get(`/api/WeighingBigData/GetWarehouseGrinLoss`, {
    params,
  });

/**
 * @method 仓库出库占比
 */
export const getWarehouseSaleRate = (params) =>
  api.get(`/api/WeighingBigData/GetWarehouseSaleRate`, {
    params,
  });

/**
 * @method 交易市场分布
 */
export const getMallMap = (params) =>
  api.get(`/api/WeighingBigData/GetMallMap`, {
    params,
  });

/**
 * @method 基地地图分布
 */
export const getDepotMap = (params) =>
  api.get(`/api/WeighingBigData/GetDepotMap`, {
    params,
  });

/**
 * @method 获取交易市场分布走向图--详细
 */
export const getAreaSale = (params) =>
  api.get(`/api/WeighingBigData/GetAreaSale`, {
    params,
  });

/**
 * @method 累计交易量进入--交易量走势图
 */
export const getTrendVolumeTrendLine = (params) =>
  api.get(`/api/WeighingBigData/GetDealQuantity`, {
    params,
  });

/**
 * 获取平仓管理
 */

export const getPingcang = (params) =>
  api.get(`/api/WeighingLiquidationHis`, {
    params,
  });

/**
 * 平仓状态
 */
export const pingStatus = (params) =>
  api.post(`/api/WeighingLiquidationHis/UpdateStatus`, params);

/**
 * 挂单/作废单
 */
export const getNoSettleBalance = (params) =>
  api.get(`/api/TransactionReport/GetCancelReport`, {
    params,
  });

/**
 * 大数据 2020 12 28 -----------------------------------------------------------------------------
 */

// 养殖产量分布图
export const getAreaOutput = () => api.get(`/api/BigData/AreaOutput`, {});

// 30天销售额，今日销售额 ，最新成交价，基地数量，养殖面积，塘口数量
export const getRealTimeBaseAndSale = () =>
  api.get(`/api/BigData/RealTimeBaseAndSale`);

// 累计销售额+累计销量
export const getRealTimeTotal = () => api.get(`/api/BigData/RealTimeTotal`, {});

// 渔场物联网
export const getIotAreaCount = () =>
  api.get(`/api/BigData/GetIotAreaCount`, {});

// 渔联网总用户数
export const getUserCount = () => api.get(`/api/BigData/UserCount`, {});

// 鱼塘塘口面积
export const getPondAreaCount = () => api.get(`/api/BigData/PondAreaCount`, {});

// 养殖基地个数
export const getFishBaseCount = () => api.get(`/api/BigData/fishBaseCount`, {});

// 养殖类型占比
export const getCultivationTypeRate = () =>
  api.get(`/api/BigData/CultivationTypeRate`, {});

// 损失占比
export const getLossRate = () => api.get(`/api/BigData/LossRate`, {});

// 养殖品种
export const getBreedRate = () => api.get(`/api/BigData/BreedRate`, {});

/**
 * @method 获取商品类别
 */
export const getCategory = () => api.get("api/Fish/GetCategory");

/**
 * @method 获取首页数据
 */
export const getHome = (params) => api.get("api/OrderMallHome", { params });

/**
 * @method 获取首页报表数据（按产品汇总）
 */
export const getGroupByProduct = (params) =>
  api.get("api/OrderMallHome/GetGroupByProduct", { params });

/**
 * @method 获取首页报表数据（按客户汇总）
 */
export const getGroupByDealer = (params) =>
  api.get("api/OrderMallHome/GetGroupByDealer", { params });

/**
 * @method 定金比例设置
 */
export const setEarnestAmount = (params) =>
  api.post("/api/CommodityMall/SetEarnestAmount", params);

/**
 * @method 定金比例获取
 */
export const getEarnestAmount = (params) =>
  api.get("/api/CommodityMall/GetEarnestAmount", { params });

/**
 * @method 获取商品列表
 */
export const getProductList = (params) =>
  api.get("/api/WeighingProduct", {
    params,
  });

/**
 * @method 新增商品
 */
export const addProduct = (params) =>
  api.post(`/api/WeighingProduct/Add`, params);

/**
 * @method 订单列表
 */
export const getOrderList = (params) =>
  api.get(`/api/MerchantBack`, { params });

/**
 * @method 订单详情
 */
export const getOrderDetail = (numberOrder) =>
  api.get(`/api/OrderMall/GetByNumberOrder?numberOrder=${numberOrder}`, {});

/**
 * 修改订单金额
 */
export const UpdateOrderPrice = (params) =>
  api.post(`/api/MerchantBack/UpdateOrderPrice`, params);
/**
 * @method 上下架商品
 */
export const setProStatus = (params) =>
  api.put(`/api/CommodityMall/SetStatus`, params);

/**
 * @method 获取订单数量
 */
export const getOrderSum = () =>
  api.get(`/api/MerchantBack/GetMerchantBackOrderCount`);

/**
 * @method 订单处理
 */

export const setOrder = (params) =>
  api.post(`/api/MerchantBack/SetOrderStatus`, params);

/**
 * @method 订单处理删除订单
 */
export const delOrder = (numberOrder) =>
  api.delete(`/api/OrderMall?numberOrder=${numberOrder}`);

/**
 * @method 渔联交易通首页获取销售堆积表
 */
export const getHomeAmount = () => api.get(`/api/OrderMallHome/Amount`);

/**
 * @method 获取入场登记单
 */
export const getEntrance = (params) => api.get(`/api/Entrance`, { params });

/**
 * @method 生成系统批次号
 */
export const getBatch = () => api.get(`/api/WeighingBatch/GenerateSysBatchNo`);

/**
 * @method 获取供应商列表
 */
export const getWeighingDealer = (params) =>
  api.get(`/api/WeighingDealer`, { params });

/**
 * @method 获取车辆列表
 */
export const getCarList = (params) =>
  api.get(`/api/WeighingCarInfo/GetPage`, { params });

/**
 * @method 获取仓库列表
 */
export const getWarehouseList = (params) =>
  api.get(`/api/WeighingDepot/GetPage`, { params });

/**
 * @method 获取员工列表
 */
export const getEmployee = (params) => api.get(`/api/User/Page`, { params });

/**
 * @method 新增入场登记
 */
export const addEntrance = (params) => api.post(`/api/Entrance`, params);

/**
 * @method 获取入场登记二维码地址
 */
export const getQRcodeUrl = (batch) =>
  api.get(`/api/Entrance/GetQRcodeUrlAsync?batch=${batch}`);

/**
 * --------- 检测管理 -----------
 */

// 获取检测列表（PC端）
export const getCheckList = (params) =>
  api.get(`/api/BatchDetection/GetToPc`, { params });

// 获取检测详情
export const getCheckDetail = (batch) =>
  api.get(`/api/WeighingBatch/GetByBatch?batch=${batch}`);

// 检测批次（PC端）
export const detectionBatchToPC = (params) =>
  api.put(`/api/BatchDetection/DetectionBatchToPC`, params);

// 获取检测机构
export const getOrgan = (params) =>
  api.get(`/api/JYTInspectionOrganization`, { params });

// 新增检测机构
export const addOrgan = (params) =>
  api.post(`/api/JYTInspectionOrganization`, params);

// 新增检测机构
export const editOrgan = (params) =>
  api.put(`/api/JYTInspectionOrganization`, params);

// 获取检测机构编辑视图
export const getOrganDetail = (id) =>
  api.get(`/api/JYTInspectionOrganization/${id}`);

// 删除检测机构
export const deleteOrgan = (id) =>
  api.delete(`/api/JYTInspectionOrganization/${id}`);

// 获取批次（检测列表）类型数量
export const getCheckCount = (params) =>
  api.get(`/api/BatchDetection/GetCount`, { params });

// 设备管理
/**
 * 操作员--设备管理下的负责人
 */
export const getYtcUser = (PageIndex, PageSize) =>
  api.get(`/api/YTCUser?PageIndex=${PageIndex}&PageSize=${PageSize}`, {});

/**
 * 添加设备
 */
export const addEquipment = (data) => api.post(`/api/JYTDevice`, data);
/**
 * 编辑设备
 */
export const putEquipment = (data) => api.put(`/api/JYTDevice`, data);
/**
 * 获取单个设备
 */
export const getSingleDevice = (id) => api.get(`/api/JYTDevice/${id}`);
/**
 * 删除设备
 */
export const deleteDevice = (id) => api.delete(`/api/JYTDevice/${id}`);
/**
 * 设备管理-列表
 */
export const getEquipmentList = (
  PageIndex,
  PageSize,
  DeviceNumber,
  deviceType,
  SortType,
  Location
) =>
  api.get(
    `/api/JYTDevice?PageIndex=${PageIndex}&PageSize=${PageSize}&DeviceNumber=${DeviceNumber}&deviceType=${deviceType}&SortType=${SortType}&Location=${Location}`,
    {}
  );
/**
 * 设备管理--所在地下拉
 */

export const getAreaList = () =>
  api.get("/api/YTCDevice/GetLocationDropdownList", {});
/** 线上充值 2021 5 27 ------------------------------------------  */

// 线上 - 现金充值
export const cashRecharge = (params) =>
  api.post(`/api/WeighingCardInfo/CashRecharge`, params);

// 线上 - 扫码充值
export const scanQRRecharge = (params) =>
  api.post(`/api/WeighingCardInfo/ScanQRRecharge`, params);

// 验证扫码充值是否支付成功（成功则返回小票信息）
export const vaildScanQRRecharge = (params) =>
  api.post(`/api/WeighingCardInfo/VaildScanQRRecharge`, params);
